class ModalContent {
  constructor() {
    // Bind class methods
    this.init = this.init.bind(this);
    this.loadModalContent = this.loadModalContent.bind(this);
    this.clearContent = this.clearContent.bind(this);

    this.modalTriggerWrappersSelector = '[data-ui="modal-trigger-wrapper"]';
    this.modalSelector = 'modal-flexible';
    this.modalBodySelector = '[data-ui="modal-body"]';
    this.modalTitleSelector = '[data-ui="modal-title"]';
    this.modalClasses = {
      person: 'acg-modal--people'
    };
    this.modalType = 'person';
    this.modalContentID = 0;

    // Initialize component on load
    document.addEventListener('DOMContentLoaded', this.init);
  }

  init() {
    const modalTriggerWrappers = document.querySelectorAll(
      this.modalTriggerWrappersSelector
    );

    this.modalBody = document.querySelector(this.modalBodySelector);
    this.modalTitle = document.querySelector(this.modalTitleSelector);
    this.modal = document.getElementById(this.modalSelector);

    // Bind click listener to all present modal triggers
    if (modalTriggerWrappers) {
      modalTriggerWrappers.forEach(trigger =>
        trigger.addEventListener('click', this.loadModalContent)
      );
      this.fetchData();
    }

    if (this.modal) {
      this.modal.addEventListener('arch-modal-close', this.clearContent);
    }
  }

  async fetchData() {
    const apiSettings = window.WP_API_Settings;

    if (!apiSettings) {
      return;
    }

    this.wp = new WPAPI({
      endpoint: apiSettings.root,
      nonce: apiSettings.nonce
    });

    this.registerRoutes();
  }

  registerRoutes() {
    this.wp.contacts = this.wp.registerRoute('wp/v2', '/contact/(?P<id>)', {
      // Listing any of these parameters will assign the built-in
      // chaining method that handles the parameter:
      params: [
        'before',
        'after',
        'author',
        'parent',
        'post',
        'filter',
        'tags_exclude'
      ]
    });
  }

  async injectContactContent() {
    const contact = await this.wp.contacts().id(this.modalContentID);

    const { acf, content } = contact;

    const fields = {
      name: acf.contact_full_name,
      image: acf.contact_headshot,
      title: acf.contact_job_title,
      description: content.rendered,
      phone: acf.contact_direct_phone_number,
      mobile: acf.contact_mobile_phone_number,
      email: acf.contact_email_address,
      territory: acf.contact_territory,
      linkedin: acf.contact_linkedin
    };

    const phoneLink = fields.phone
      .trim()
      .replace(/\(/g, '')
      .replace(/\)/g, '')
      .replace(/\+ /, '+')
      .replace(/ /g, '-');

    const mobileLink = fields.mobile
      .trim()
      .replace(/\(/g, '')
      .replace(/\)/g, '')
      .replace(/\+ /, '+')
      .replace(/ /g, '-');

    this.modal.classList.add(this.modalClasses.person);

    const contactMarkup = `
    <div class="acg-profile">
    ${
      fields.image
        ? `<div class="acg-profile__image-wrapper">
        <img class="acg-profile__image" alt="Profile image" src=${
          fields.image
        } />
     <div class="acg-profile__contact">
      <ul class="acg-profile__contact-info">
        ${
          fields.phone
            ? `<li><i class="acg-icon fas fa-phone" aria-label="Phone icon"></i> ${
                fields.mobile ? '<strong>Direct:</strong> ' : ''
              } <a href="tel:${phoneLink}" target="_blank">${
                fields.phone
              }</a></li>`
            : ''
        }
        ${
          fields.mobile
            ? `<li><i class="acg-icon fas fa-phone" aria-label="Phone icon"></i> ${
                fields.mobile ? '<strong>Mobile:</strong> ' : ''
              } <a href="tel:${mobileLink}" target="_blank">${
                fields.mobile
              }</a></li>`
            : ''
        }
        ${
          fields.email
            ? `<li><i class="acg-icon fas fa-envelope" aria-label="E-mail icon"></i> <a href="mailto:${fields.email}">${fields.email}</a></li>`
            : ''
        }
        ${
          contact.region[0] === 122
            ? `<li><i class="acg-icon fas fa-map-marked-alt" aria-label="Map icon"></i> ${
                fields.territory ? fields.territory : 'N/A'
              }</li>`
            : ''
        }
        ${
          fields.linkedin
            ? `<li><i class="acg-icon fab fa-linkedin-in" aria-label="LinkedIn icon"></i> <a href="${fields.linkedin}" target="_blank" rel="noreferrer noopener">Connect on LinkedIn</a></li>`
            : ''
        }
      </ul>
     </div>
    </div>`
        : ''
    }
    <div class="acg-profile__detail">
      <h2 class="acg-profile__name acg-type-display--small" id="modal-title">${
        fields.name
      }</h2>
      <h3 class="acg-profile__title">${fields.title}</h3>
      <p class="acg-profile_description">${fields.description}</p>

      ${
        !fields.image
          ? `<div class="acg-profile__contact">
      <ul class="acg-profile__contact-info">
        ${
          fields.phone
            ? `<li><i class="acg-icon fas fa-phone" aria-label="Phone icon"></i>${
                fields.mobile ? '<strong>Direct:</strong> ' : ''
              } <a href="tel:${phoneLink}" target="_blank">${
                fields.phone
              }</a></li>`
            : ''
        }
        ${
          fields.mobile
            ? `<li><i class="acg-icon fas fa-phone" aria-label="Phone icon"></i> ${
                fields.phone ? '<strong>Mobile:</strong>' : ''
              } ${fields.mobile}</li>`
            : ''
        }
        ${
          fields.email
            ? `<li><i class="acg-icon fas fa-envelope" aria-label="E-mail icon"></i> <a href="mailto:${fields.email}">${fields.email}</a></li>`
            : ''
        }
        ${
          contact.region[0] === 122
            ? `<li><i class="acg-icon fas fa-map-marked-alt" aria-label="Map icon"></i> ${
                fields.territory ? fields.territory : 'N/A'
              }</li>`
            : ''
        }
        ${
          fields.linkedin
            ? `<li><i class="acg-icon fab fa-linkedin-in" aria-label="LinkedIn icon"></i> <a href="${fields.linkedin}" target="_blank" rel="noreferrer noopener">Connect on LinkedIn</a></li>`
            : ''
        }
      </ul>
     </div>`
          : ''
      }
    </div>
  </div>
    `;

    this.modalTitle.style.cssText = 'display: none;';
    this.modalBody.innerHTML = contactMarkup;
  }

  clearContent() {
    this.modalBody.innerHTML = '';
  }

  async loadModalContent(event) {
    const target = event.target;

    if (
      target.hasAttribute('data-ui') &&
      target.getAttribute('data-ui') === 'modal-trigger'
    ) {
      const trigger = event.target;

      this.modalType = trigger.getAttribute('data-modal-type');
      this.modalContentID = trigger.getAttribute('data-id');
      this.closeButtons = this.modal.querySelectorAll(
        '[data-ui="modal-close"]'
      );

      this.closeButtons.forEach(button => {
        button.addEventListener('click', this.clearData);
      });

      switch (this.modalType) {
        case 'person':
          this.injectContactContent();
          break;
        default:
          this.modalTitle.innerHTML = 'Error';
          this.modalBody.innerHTML = `<p>No Modal Content</p>`;
      }
    }
  }
}

export default ModalContent;
